<template>
  <!--          <div class="styleCard">-->
  <!--              <ul class="style-nav style2">-->
  <!--                                  <li-->
  <!--                                     v-for="range in timeRanges"-->
  <!--                                     :key="range.id"-->
  <!--                                     id="range.name"-->
  <!--                                     :class="{ active: selectedTimeRange === range.alias }"-->
  <!--                                     @click="selectedTimeRange = range.alias"-->
  <!--                                  >{{range.name}}</li>-->
  <!--              </ul>-->
  <div class="styleCardContent">
    <div class="Counters_wraper">
      <div v-if="countAgents" class="total_Counter">
        {{ "Total Agents: " }}{{ countAgents }}
      </div>
    </div>
    <div class="main-chart-live" id="main-chart-imp"></div>
  </div>
  <!--        </div>-->
  <!--   </div>-->
</template>

<script>
import apiClientCreator from "../../../../../../helpers/api/request";
import { mapState } from "vuex";

export default {
  name: "LiveDataCharts.component",
  props: {
    selectedGraphTab: String,
    selectedTimeRange: String
  },
  computed: {
    ...mapState("clients", ["chartsMainView"])
  },
  data() {
    return {
      timeRanges: [
        {
          id: 1,
          name: "10 Minutes",
          alias: "10M",
          range: {
            type: "m",
            value: 10
          }
        },
        {
          id: 2,
          name: "30 Minutes",
          alias: "30M",
          range: {
            type: "m",
            value: 30
          }
        },
        {
          id: 3,
          name: "1 Hour",
          alias: "1H",
          range: {
            type: "h",
            value: 1
          }
        },
        {
          id: 4,
          name: "4 Hour",
          alias: "4H",
          range: {
            type: "h",
            value: 4
          }
        },
        {
          id: 5,
          name: "1 Day",
          alias: "1D",
          range: {
            type: "d",
            value: 1
          }
        },
        {
          id: 6,
          name: "1 Week",
          alias: "1W",
          range: {
            type: "w",
            value: 1
          }
        }
      ],
      //selectedTimeRange:"10M",
      linkBuilder: null,
      ArImpData: [],
      interval: null,
      countAgents: null
    };
  },
  mounted() {
    // let tempObj = this.timeRanges.filter(a=>
    //     a.alias === this.selectedTimeRange
    // )
    // this.timeRanges.reverse();
    if (this.selectedGraphTab === "LIVE_DATA") {
      this.fetchDataToChart();
    }

    // this.interval = setInterval(()=> {
    //     this.fetchDataToChart();
    // },3000);
  },

  watch: {
    // selectedTimeRange:function(){
    //     console.log(this.selectedTimeRange)
    // },
    selectedGraphTab: function() {
      if (this.selectedGraphTab !== "LIVE_DATA") {
        this.interval = clearInterval(this.interval);
      }
      if (this.selectedGraphTab === "LIVE_DATA") {
        this.fetchDataToChart();
        this.interval = setInterval(() => {
          this.fetchDataToChart();
        }, 600000);
      }
    },
    selectedTimeRange: function() {
      this.fetchDataToChart();
    }
  },

  methods: {
    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },
    getLink() {
      let tempObj = this.timeRanges.filter(
        a => a.alias === this.selectedTimeRange
      );
      this.linkBuilder = `client/stats/impression/${tempObj[0].range.type}/${tempObj[0].range.value}`;
      return this.linkBuilder;
    },

    fetchDataToChart() {
      this.ArImpData = [];
      let canvasId = "main-chart-imp";
      apiClientCreator(this.getLink())
        .get("", {})
        .then(res => {
          this.ArImpData = [];
          this.ArImpData = res.data;
          if (this.ArImpData.length > 0) {
            this.countAgents = this.ArImpData.length;
          } else {
            this.ArImpData = null;
          }
          this.createImpChart(canvasId, this.ArImpData);
        });
    },

    createImpChart(canvasId, chartData) {
      $("#" + canvasId).html("");
      let set = [];
      let chart = anychart.column();
      let yScale2 = anychart.scales.linear();
      chart.container(canvasId);
      chartData.map(item => {
        let counter = 0;
        counter =
          item.na +
          item.ca +
          item.dep +
          item.ni +
          item.bn +
          item.sms +
          item.c2c +
          item.rf +
          item.ld;

        set.push([
          this.namesFormatter(item.user.full_name),
          item.na,
          item.ca,
          item.dep,
          item.ni,
          item.bn,
          item.sms,
          item.c2c,
          item.rf,
          item.ld
        ]);
      });

      let dataSet = null;
      dataSet = anychart.data.set(set);

      let seriesData_1 = dataSet.mapAs({ x: 0, value: 1 });

      // map data for the second series, take x from the zero column and value from the second column of data set
      let seriesData_2 = dataSet.mapAs({ x: 0, value: 2 });

      // map data for the third series, take x from the zero column and value from the third column of data set
      let seriesData_3 = dataSet.mapAs({ x: 0, value: 3 });

      // map data for the fourth series, take x from the zero column and value from the fourth column of data set
      let seriesData_4 = dataSet.mapAs({ x: 0, value: 4 });
      let seriesData_5 = dataSet.mapAs({ x: 0, value: 5 });
      let seriesData_6 = dataSet.mapAs({ x: 0, value: 6 });
      let seriesData_7 = dataSet.mapAs({ x: 0, value: 7 });
      let seriesData_8 = dataSet.mapAs({ x: 0, value: 8 });
      let seriesData_9 = dataSet.mapAs({ x: 0, value: 9 });
      //seriesData_1.normal().fill("#99004d", 0.5);
      // create bar chart

      yScale2.stackMode("value");
      // turn on chart animation
      chart.animation(true);

      // set container id for the chart

      //chart.padding([10, 40, 5, 20]);

      // set scale minimum
      chart.yScale().minimum(0);
      //chart.yScale().labels()

      // force chart to stack values by Y scale.
      chart.yScale().stackMode("value");

      chart
        .yAxis()
        .labels()
        .format(function() {
          return this.value.toLocaleString();
        });

      // helper function to setup label settings for all series
      let setupSeriesLabels = function(series, name) {
        series.name(name);
        series.stroke("0 #fff 0");
        series.hovered().stroke("0 #fff 0");
      };
      chart
        .xAxis()
        .labels()
        .format(function() {
          let value = this.value;
          // limit the number of symbols to 3

          return value;
        });
      chart
        .xAxis()
        .labels()
        .fontSize(9);
      chart
        .xAxis()
        .labels()
        .padding(-0.5);

      chart.barsPadding(-0.5);

      // temp variable to store series instance
      let series;

      // create first series with mapped data
      let na = chart.column(seriesData_1);
      setupSeriesLabels(na, "NA");
      na.normal().fill("#F4511E", 1);

      // create second series with mapped data
      let ca = chart.column(seriesData_2);
      setupSeriesLabels(ca, "CA");
      ca.normal().fill("#fa8100", 0.5);

      // create third series with mapped data
      let dep = chart.column(seriesData_3);
      setupSeriesLabels(dep, "DEP");
      dep.normal().fill("#7b1fa2", 0.8);

      // create fourth series with mapped data
      let ni = chart.column(seriesData_4);
      setupSeriesLabels(ni, "NI");
      ni.normal().fill("#0c0b0b", 0.8);

      let bn = chart.column(seriesData_5);
      setupSeriesLabels(bn, "BN");
      bn.normal().fill("#00ffff", 0.8);

      let sms = chart.column(seriesData_6);
      setupSeriesLabels(sms, "SMS");
      sms.normal().fill("#d7ff00", 0.8);

      let c2c = chart.column(seriesData_7);
      setupSeriesLabels(c2c, "C2C");
      c2c.normal().fill("#9a9a9a", 0.8);

      let rf = chart.column(seriesData_8);
      setupSeriesLabels(rf, "RF");
      rf.normal().fill("#ff0000", 1);

      let ld = chart.column(seriesData_9);
      setupSeriesLabels(ld, "LD");
      ld.normal().fill("#005eff", 0.8);

      // chart.labels()
      //     .enabled(true)
      //     .format(function () {
      //         console.log(this.value)
      //            return ;
      //
      //         })
      //
      // chart.labels().format(function () {
      //    return "{%dataPlotYSum}";
      //
      // })

      chart
        .labels()
        .enabled(true)
        .format(function(index, value) {});

      // turn on legend
      chart
        .legend()
        .enabled(true)
        .fontSize(10)
        .padding([0, 0, 10, 0]);
      chart.interactivity().hoverMode("by-x");
      chart.barGroupsPadding(0);
      chart.tooltip().displayMode("union");
      let yLabels = chart.yAxis().labels();
      yLabels.fontSize(8);
      // initiate chart drawing
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    }
  }
};
</script>

<style scoped>
html * {
  text-transform: capitalize;
}
.nav-tabs a {
  height: 20px;
  padding: 5px;
}
.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 10pt;
  font-weight: bold;
  color: #1e88e5;
}
.main-chart-live {
  width: 100%;
  height: 100%;
  float: left;
  /* border: solid 1px #d6f4ff;*/
  padding: 5px;
  border-radius: 3px;
  position: relative;
}

.campaign-chart {
  width: 100%;
  height: 150px;
}

.main-chart-today {
  width: 830px;
  height: 140px;
}

.back-icon {
  cursor: pointer;
  font-size: 14pt;
  position: absolute;
  bottom: 5px;
  left: 5px;
}

.selected-user-name {
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-weight: bold;
  font-family: Montserrat;
  font-size: 9pt;
  z-index: 100000;
}

.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: 200px;
  position: relative;
  font-family: Montserrat;
  background: white;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
                                  background: white;
                                */
}
.style-nav.style2 li {
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 115px;
  height: 20px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.sysChatActions {
  position: absolute;
  bottom: 35px;
  left: 60px;
  border-top: 1px solid #ebeff2;
}
.sysChatActions button:hover img {
  transform: translateX(-10px);
}
.sysChatActions button img {
  transition: transform 0.3s ease;
}
.sysChatActions button {
  width: 75px;
  background: none;
  border: 0;
  position: absolute;
  top: 0.1rem;
  right: 0;
  text-align: center;
  cursor: pointer;
  height: 37px;
}
.loader-pos {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: -30px;
  left: 0;
}

.main-chart {
  width: 950px;
  height: 190px;
}
.Counters_wraper {
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 15px;
  top: 15px;
  z-index: 200;
}
.total_Counter {
  font-size: 1rem;
  font-weight: bold;
  float: right;
  margin-right: 10px;
}
</style>
